import { useLocation } from '@gatsbyjs/reach-router'
import { useMemo } from 'react'

import { removeDispensaryPrefixAndSlug, useDispensaryContext } from '../../dispensaries'

export interface UseCanonicalLocation {
  path: string
}

export function useCanonicalLocation(): UseCanonicalLocation {
  const dispensary = useDispensaryContext()
  const location = useLocation()
  return useMemo(() => {
    const isSSR = typeof window === 'undefined'
    const relativePath = isSSR ? location.pathname : location.href.replace(location.origin, '')
    return {
      path: dispensary ? removeDispensaryPrefixAndSlug(relativePath) : relativePath,
    }
  }, [dispensary, location.href, location.origin, location.pathname])
}
